import React, { useEffect } from "react";
import { ReactComponent as Innerpolygon } from "./SVG/inner.svg";
import { ReactComponent as Outerpolygon } from "./SVG/outer.svg";
import { ReactComponent as Engine } from "./SVG/engine.svg";
import DTimg from "./../Sections/images/DT.png";
import gsap from "gsap";
import "./Third.css";

function Third() {
  function setupThird() {
    let butnum = 0;
    const buttons = document.querySelectorAll(".button");
    for (let i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener("click", handleClick);
    }
    buttons[0].classList.add("pulsebutton");
    function checkComplete(x) {
      butnum = butnum + x;
      if (butnum === 3) {
        const letters = document.querySelectorAll(".st2");
        for (let i = 0; i < letters.length; i++) {
          gsap.to(letters[i], { fill: "#FFFFFF", duration: 0.4 });
        }
        const lines = document.querySelectorAll(".st1");
        let tl = gsap.timeline({
          yoyo: true,
          repeat: -1,
        });
        for (let i = 0; i < lines.length; i++) {
          tl.fromTo(
            lines[i],
            { stroke: "#616161c3" },
            { stroke: "#FFFFFF", duration: 2.7, ease: "Sine.easeInOut" },
            "<"
          );
        }
        tl.play();
        setTimeout(() => {
          document
            .getElementById("Layer_1")
            .style.setProperty(
              "-webkit-filter",
              "drop-shadow(0px 0px 5px rgba(255,255,255, 0.4)"
            );
          document
            .getElementById("Layer_2")
            .style.setProperty(
              "-webkit-filter",
              "drop-shadow(0px 0px 2px rgba(255,255,255, 0.4)"
            );
          let mh = document.getElementById("midheadings");
          let engine = document.getElementById("engine");
          let layer2 = document.getElementById("Layer_2");
          let tl_mh = gsap.timeline({
            onComplete: () => {
              document.getElementById("button-1").style.display = "none";
              document.getElementById("button-2").style.display = "none";
              document.getElementById("button-3").style.display = "none";
              document.getElementById("statement").style.display = "none";
              gsap.to(document.getElementById("scrolldown"), {
                opacity: 1,
                duration: 1,
              });
            },
          });
          tl_mh.to(mh, {
            opacity: 0,
            duration: 1,
          });
          tl_mh.to(layer2, { height: "72%", duration: 1 }, "<");
          tl_mh.to(engine, { opacity: 1, width: "36%", duration: 2 }, ">");
          tl_mh.to(
            document.getElementById("button-1"),
            { opacity: 0, duration: 2 },
            "<"
          );
          tl_mh.to(
            document.getElementById("button-2"),
            { opacity: 0, duration: 2 },
            "<"
          );
          tl_mh.to(
            document.getElementById("button-3"),
            { opacity: 0, duration: 2 },
            "<"
          );
          tl_mh.to(
            document.getElementById("DTimgid"),
            { opacity: 0, duration: 2 },
            "<"
          );
          tl_mh.to(
            document.getElementById("statement"),
            { opacity: 0, duration: 1 },
            ">"
          );
          tl_mh.play();
          debugger;
        }, 800);
      }
    }
    function handleClick(e) {
      let tl = gsap.timeline();
      switch (e.target.id) {
        case "button-1":
          tl.clear();
          tl.to(document.getElementById("line-1"), {
            stroke: "#FFFFFF",
            duration: 0.2,
          });
          tl.to(
            document.getElementById("line-2"),
            {
              stroke: "#FFFFFF",
              duration: 0.2,
              delay: 0.2,
            },
            "<"
          );
          tl.to(
            document.getElementById("line-3"),
            {
              stroke: "#FFFFFF",
              duration: 0.2,
              delay: 0.2,
            },
            "<"
          );
          tl.to(
            document.getElementById("line-4"),
            {
              stroke: "#FFFFFF",
              duration: 0.2,
              delay: 0.2,
            },
            "<"
          );
          tl.to(
            document.getElementById("line-5"),
            {
              stroke: "#FFFFFF",
              duration: 0.2,
              delay: 0.2,
            },
            "<"
          );
          tl.to(document.getElementById("heading-1"), {
            color: "#FFFFFF",
            duration: 0.5,
            onComplete: () => {
              checkComplete(1);
            },
          });
          tl.to(document.getElementById("button-1"), {
            color: "rgba(255,255,255, 0.4)",
            border: "0.5px solid rgba(255,255,255, 0.4)",
            duration: 0.5,
            onComplete: () => {
              document.getElementById("button-1").classList.add("nohover");
              document
                .getElementById("button-1")
                .classList.remove("pulsebutton");
              document.getElementById("button-2").classList.add("pulsebutton");
            },
          });
          tl.play();

          break;
        case "button-2":
          tl.clear();
          tl.to(document.getElementById("line-6"), {
            stroke: "#FFFFFF",
            duration: 0.2,
          });
          tl.to(
            document.getElementById("line-7"),
            {
              stroke: "#FFFFFF",
              duration: 0.2,
              delay: 0.2,
            },
            "<"
          );
          tl.to(
            document.getElementById("line-8"),
            {
              stroke: "#FFFFFF",
              duration: 0.2,
              delay: 0.2,
            },
            "<"
          );
          tl.to(
            document.getElementById("heading-2"),
            {
              color: "#FFFFFF",
              duration: 0.5,
              onComplete: () => {
                checkComplete(1);
              },
            },
            ">"
          );
          tl.to(document.getElementById("button-2"), {
            color: "rgba(255,255,255, 0.4)",
            border: "0.5px solid rgba(255,255,255, 0.4)",
            duration: 0.5,
            onComplete: () => {
              document.getElementById("button-2").classList.add("nohover");
              document
                .getElementById("button-2")
                .classList.remove("pulsebutton");
              document.getElementById("button-3").classList.add("pulsebutton");
            },
          });
          tl.play();
          break;
        case "button-3":
          tl.clear();
          tl.to(document.getElementById("line-9"), {
            stroke: "#FFFFFF",
            duration: 0.2,
          });
          tl.to(
            document.getElementById("line-10"),
            {
              stroke: "#FFFFFF",
              duration: 0.2,
              delay: 0.2,
            },
            "<"
          );
          tl.to(
            document.getElementById("line-11"),
            {
              stroke: "#FFFFFF",
              duration: 0.2,
              delay: 0.2,
            },
            "<"
          );
          tl.to(
            document.getElementById("line-12"),
            {
              stroke: "#FFFFFF",
              duration: 0.2,
              delay: 0.2,
            },
            "<"
          );
          tl.to(
            document.getElementById("heading-3"),
            {
              color: "#FFFFFF",
              duration: 0.5,
              onComplete: () => {
                checkComplete(1);
              },
            },
            ">"
          );
          tl.to(document.getElementById("button-3"), {
            color: "rgba(255,255,255, 0.4)",
            border: "0.5px solid rgba(255,255,255, 0.4)",
            duration: 0.5,
            onComplete: () => {
              document.getElementById("button-3").classList.add("nohover");
              document
                .getElementById("button-3")
                .classList.remove("pulsebutton");
            },
          });
          tl.play();
          break;
        default:
          break;
      }
    }
  }
  useEffect(() => {
    setupThird();
  }, []);
  return (
    <section className="third">
      <div className="outer">
        <div className="inner">
          <div className="bg">
            <div id="DTimgid" className="DTimgdiv">
              <img src={DTimg} alt="DT" className="DTimg" id="DTid" />
            </div>
            <Outerpolygon />
            <Innerpolygon />
            <Engine id="engine" />
            <div className="mid-headings" id="midheadings">
              <div className="row">
                <div id="heading-1" className="heading">
                  PLAN AND SUPPORT
                </div>
                <div id="heading-2" className="heading">
                  BUILD AND OBTAIN
                </div>
                <div id="heading-3" className="heading">
                  EXHIBIT AND EXPLAIN
                </div>
              </div>
            </div>
            <div className="buttons">
              <div className="row-button">
                <div className="statement-third" id="statement">
                  <span>DIGITAL CORE</span>
                  <span className="statement-small">FOR THE</span>
                  <span>MODERN AGE</span>
                </div>
                <div id="button-1" className="button">
                  FRAMEWORK
                </div>
                <div id="button-2" className="button">
                  SOURCE
                </div>
                <div id="button-3" className="button">
                  DEMONSTRATE
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Third;
